import { useTranslation } from 'react-i18next'
import contentData from '../../data/content.json'
import RichText from '../ui/RichText'

function Services() {
  const { t } = useTranslation()
  const services = t('pages.home.sections.services.cards', { returnObjects: true })

  const serviceImages = [
    contentData.images.tctsyCard,
    contentData.images.gentleYogaCard,
  ]

  const handleScrollTo = (href) => {
    if (href.startsWith('/#')) {
      const elementId = href.substring(2)
      const element = document.getElementById(elementId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    }
  }

  return (
    <section id="services" className="section-container bg-beige py-80">
      <div className="content-wrapper">
        <h2 className="text-lato-bold text-center mb-40">
          {t('pages.home.sections.services.heading')}
        </h2>

        <div className="grid grid-cols-1 tablet:grid-cols-2 gap-40">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-beige rounded-md p-40 flex flex-col gap-40 h-full"
            >
              <img
                src={serviceImages[index].url}
                alt={serviceImages[index].alt}
                className="w-full h-[250px] tablet:h-[300px] object-cover rounded-md"
              />

              <div className="flex flex-col gap-12 text-center flex-1">
                <h3 className="text-lato-bold text-xl">{service.title}</h3>
                <RichText text={service.description} className="text-lato-regular" />
              </div>

              <button
                onClick={() => handleScrollTo(service.ctaButton.href)}
                className="w-full max-w-xs mx-auto h-40 bg-button-primary text-white rounded-sm flex items-center justify-center text-lato-regular hover:bg-button-primary-hover transition-colors mt-auto"
              >
                {service.ctaButton.text}
              </button>
            </div>
          ))}
        </div>
      </div>
    </section>
  )
}

export default Services
